export default class Brick {
  constructor(iframeOrElement, config) {
    this.id = config.id;
    this.config = config;
    this.iframe = iframeOrElement;
    this.element = iframeOrElement;
  }
}



// WEBPACK FOOTER //
// ./src/models/brick.js